import { render, staticRenderFns } from "./goodManager.vue?vue&type=template&id=69ca1d81&scoped=true&"
import script from "./goodManager.vue?vue&type=script&lang=js&"
export * from "./goodManager.vue?vue&type=script&lang=js&"
import style0 from "./goodManager.vue?vue&type=style&index=0&id=69ca1d81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ca1d81",
  null
  
)

export default component.exports